import { ListOutline } from '@lyearn/icons';
import { DatabaseFieldTypeEnum } from '@/types/schema';

export const MultiSelectFieldStaticConfig = {
  Icon: ListOutline,
  type: DatabaseFieldTypeEnum.MultiSelect,
  labelKey: 'Database:DataTypes.MultiSelect',
};
